export const DAO_CODE = 'EXPENSES' + '_DAO';
